import { Button, Column, ErrorIcon, Icon, Typography } from '@viewup/ui';

export interface ErrorTemplateProps {
  errorHandleButtonText?: string;
  onClickErrorHandle?: () => void;
  subTitle?: string;
  title: string;
}

export const ErrorTemplate = ({
  title,
  subTitle,
  errorHandleButtonText,
  onClickErrorHandle,
}: ErrorTemplateProps) => {
  return (
    <Column alignItems='center' p={32} width={'100%'}>
      <Icon color='icon.tertiary' mb={16} size={'L'} source={ErrorIcon} />
      <Typography color='text.tertiary' fontType='header3.bold'>
        {title}
      </Typography>

      {subTitle && (
        <Typography color='text.tertiary' fontType='body2.regular'>
          {subTitle}
        </Typography>
      )}

      {errorHandleButtonText && onClickErrorHandle && (
        <Button
          onClick={onClickErrorHandle}
          size='S'
          styledComponents={{ root: { mt: 16 } }}
          variant='outline.assistive'
        >
          {errorHandleButtonText}
        </Button>
      )}
    </Column>
  );
};
